export interface Promotion {
  id: number;
  title: string;
  description: string;
  imageUrl: string;
  badge: string;
  isActive: boolean;
}

export const promotions: Promotion[] = [
  {
    id: 1,
    title: '新人首存大礼包',
    description: '新用户首次存款即享100%赠送，最高可达888元。注册后24小时内完成首存还可获得额外免费旋转机会。',
    imageUrl: 'https://readdy.ai/api/search-image?query=Luxurious%20welcome%20gift%20with%20golden%20ribbon%20and%20sparkles%20on%20dark%20velvet%20background%2C%20red%20and%20gold%20Chinese%20decorative%20elements&width=600&height=350&seq=promo-welcome&orientation=landscape',
    badge: '新人专享',
    isActive: true,
  },
  {
    id: 2,
    title: '每日返水0.8%',
    description: '所有游戏每日结算返水，最高可达0.8%。返水金额无上限，自动到账无需申请，让您的每一注都物超所值。',
    imageUrl: 'https://readdy.ai/api/search-image?query=Stacked%20golden%20coins%20with%20upward%20trend%20arrow%2C%20dark%20luxurious%20background%2C%20cashback%20concept%20with%20warm%20golden%20lighting&width=600&height=350&seq=promo-rebate&orientation=landscape',
    badge: '每日福利',
    isActive: true,
  },
  {
    id: 3,
    title: '周末狂欢翻倍',
    description: '每周末指定时段投注特定游戏，彩金最高翻3倍。周末累计投注额排名前50的玩家还可获得额外奖励。',
    imageUrl: 'https://readdy.ai/api/search-image?query=Exciting%20weekend%20party%20celebration%20with%20golden%20confetti%20and%20sparkling%20lights%2C%20dark%20nightclub%20atmosphere%2C%20luxurious%20gold%20and%20red%20decor&width=600&height=350&seq=promo-weekend&orientation=landscape',
    badge: '限时活动',
    isActive: true,
  },
  {
    id: 4,
    title: 'VIP尊享计划',
    description: '加入VIP俱乐部享受专属客服、更高返水比例、生日礼包、优先体验新游戏等特权。累计投注达标即可升级。',
    imageUrl: 'https://readdy.ai/api/search-image?query=Premium%20VIP%20golden%20membership%20card%20with%20crown%20and%20diamond%20accents%2C%20dark%20luxurious%20velvet%20background%2C%20exclusive%20VIP%20lifestyle&width=600&height=350&seq=promo-vip-plan&orientation=landscape',
    badge: 'VIP专属',
    isActive: true,
  },
];